/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from "../../../../SpecialtyPersonalStyles.module.scss"
import metadata from './StorageFacilityExp.metadata.json5';

function StorageFacilityExp(props) {

    const {
        data: stoFacExpVM,
        updateWizardData,
        submissionVM,
        storageFacPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    const addStoFacExp = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            stoFacExpVM.value = stoFacExpVM.value || []

            const { _xCenter, _dtoName } = stoFacExpVM;

            let index = 1

            if (_.isEmpty(stoFacExpVM.value)) {
                index = 1
            } else {
                index = stoFacExpVM.value[stoFacExpVM.value.length - 1].numFie + 1
            }

            const stoFacExpObjVM = viewModelService.create(
                { numFie: index },
                _xCenter,
                _dtoName
            );

            stoFacExpObjVM.isValidationReq = true;

            stoFacExpVM.pushElement(
                stoFacExpObjVM
            );
            updateWizardData(submissionVM);
        },
        [stoFacExpVM, viewModelService, updateWizardData, submissionVM]
    );

    const handleValueChange = useCallback(
        () => {

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            stoFacExpVM.value.splice(index, 1);

            _.set(submissionVM.value, storageFacPath, stoFacExpVM.value);
            updateWizardData(submissionVM);
        }, [stoFacExpVM.value, submissionVM, storageFacPath, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                const value = item.numFie ? item.numFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        readOnly
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.numFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'uniNumFie') {
                const value = item.uniNumFie ? item.uniNumFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.uniNumFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'desofProCovFie') {
                const value = item.desofProCovFie ? item.desofProCovFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desofProCovFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [handleValueChange])

    const removeStoFacExpTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`StorageFacilityExpTable`]: {
            data: stoFacExpVM.value,
        }

    }), [stoFacExpVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addStoFacExp,
            getTableCell,
            removeStoFacExpTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            stoFacExpVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [stoFacExpVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={stoFacExpVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

StorageFacilityExp.propTypes = wizardProps;
export default withRouter(StorageFacilityExp);
